import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TickCircle = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.275 30 2 23.725 2 16C2 8.275 8.275 2 16 2C23.725 2 30 8.275 30 16C30 23.725 23.725 30 16 30ZM16 4C9.387 4 4 9.387 4 16C4 22.613 9.387 28 16 28C22.613 28 28 22.613 28 16C28 9.387 22.613 4 16 4Z" />
		<path d="M24 11C24 10.45 23.55 10 23 10C22.725 10 22.475 10.113 22.288 10.287L13.001 19.587L9.71398 16.299C9.53898 16.124 9.28898 16.011 9.00098 16.011C8.45098 16.011 8.00098 16.461 8.00098 17.011C8.00098 17.286 8.11398 17.536 8.28798 17.723L12.288 21.723C12.488 21.923 12.738 22.011 13.001 22.011C13.264 22.011 13.513 21.911 13.714 21.723L23.714 11.723C23.889 11.523 24.002 11.273 24.002 10.998L24 11Z" />
	</svg>
);

export default TickCircle;
